module.exports = __webpack_public_path__ + "static/media/ascom-pn.3e4e8141.png";